import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFill = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.959 3.773a2.185 2.185 0 0 0-3.927 0l-4.384 9.019-9.79 1.445c-.818.123-1.5.696-1.752 1.48a2.193 2.193 0 0 0 .539 2.229l7.103 7.029-1.677 9.933a2.188 2.188 0 0 0 3.184 2.29l8.747-4.67 8.747 4.67c.736.39 1.63.335 2.304-.156a2.194 2.194 0 0 0 .88-2.134l-1.684-9.933 7.103-7.029c.587-.58.798-1.445.539-2.23a2.187 2.187 0 0 0-1.752-1.479l-9.797-1.445-4.383-9.02Z" })
});
export default SvgStarFill;
